module.exports = __webpack_public_path__ + "static/bg.812631fd.png";